import { render, staticRenderFns } from "./CheckboxModule.vue?vue&type=template&id=9ebc3f8e&"
import script from "./CheckboxModule.vue?vue&type=script&lang=js&"
export * from "./CheckboxModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports